import React, { useState } from 'react';
import { Button } from '../../../Core';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';
import { PortionSievingAddSieveDialog } from '.';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';

let PortionSievingAddSieveButton: React.FC<IWorksheetComponent> = () => {
  const [showAddSieveDialog, setShowAddSieveDialog] = useState(false);
  return (
    <>
      <Button onClick={() => setShowAddSieveDialog(true)}>Add Sieve</Button>
      <PortionSievingAddSieveDialog visible={showAddSieveDialog} onClose={() => setShowAddSieveDialog(false)} />
    </>
  );
};
PortionSievingAddSieveButton = withInjectedProps(PortionSievingAddSieveButton);

export { PortionSievingAddSieveButton };
